export default "__VITE_PUBLIC_ASSET__764dde3d__"